export enum ActionTypes {
  GetTeammates = 'getTeammates',
  GetTeammatesRequest = 'getTeammates.request',
  GetTeammatesSuccess = 'getTeammates.success',
  GetTeammatesFailure = 'getTeammates.failure',
}
